/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

export const BaseNewBlogPostFragment = gql`
  fragment BaseNewBlogPostFragment on NewBlogPost {
    sys {
      id
    }
    author {
      __typename
      ... on Entry {
        sys {
          id
        }
      }
    }
    body {
      json
    }
    categories {
      __typename
      ... on Entry {
        sys {
          id
        }
      }
    }
    featureImage {
      url
      title
      description
      contentType
    }
    publishDate
    seo {
      __typename
      ... on Entry {
        sys {
          id
        }
      }
    }
    seoDescription
    seoTitle
    slug
    summary
    tags
    title
  }
`;
